import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from '@ouster/webviz-react-components';

import { ReactNode } from 'react';

interface ModalContainerProps {
  isOpen: boolean;
  isCentered?: boolean;
  onClose: () => void;
  header?: ReactNode;
  footer?: ReactNode;
  content: ReactNode;
}

export default function ModalContainer({
  isOpen,
  onClose,
  header,
  footer,
  content,
  isCentered = true,
}: ModalContainerProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered={isCentered} data-testid="modal-container-root">
      <ModalOverlay backdropFilter="auto" backdropBlur="8px" zIndex={2000} />
      <ModalContent
        fontSize={16}
        minWidth="max-content"
        containerProps={{
          zIndex: '2000',
        }}
      >
        {header && (
          <ModalHeader
            fontSize={18}
            paddingBlock={6}
            color="var(--ouster-colors-royal-200)"
            borderBottom="1px solid var(--ouster-colors-gray-400)"
            textTransform="uppercase"
            data-testid="modal-container-header"
          >
            {header}
          </ModalHeader>
        )}
        <ModalCloseButton />
        <ModalBody
          py="2em"
          maxHeight="80vh"
          overflow="hidden"
          display="grid"
          gridTemplateRows="1fr"
          data-testid="modal-container-body"
        >
          {content}
        </ModalBody>
        {footer && <ModalFooter data-testid="modal-container-footer">{footer}</ModalFooter>}
      </ModalContent>
    </Modal>
  );
}
